<template>
  <div :class="wrpperClass">
    <div class="advisory-content">
      <h3 class="mb-s clearfix">
        <span class="status">{{ statusText }}</span>
        {{ advi.reviewContent }}
        <span class="time pull-right">{{ advi.reviewTime }}</span>
      </h3>
      <!-- <p class="mb-s fz-small">{{ advi.content }}</p> -->
      <div class="details">
        <div
          v-for="(key, i) in Object.keys(textRefs.advisory)"
          :key="i"
          :class="`detail ${key}`"
        >
          <p class="detail-title">{{ textRefs.advisory[key] }}</p>
          <p :style="{whiteSpace: 'pre-wrap'}">{{ sortedAdvi[key] }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { advisory, quesType, orderType } from '@/staticData/textRefs';

  export default {
    props: {
      advi: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        textRefs: { advisory, quesType, orderType }
      };
    },
    computed: {
      wrpperClass() {
        const { advi } = this;
        return {
          'user-card': true,
          'padding-m': true,
          'shadow-wrapper': true,
          'decoration-left': true,
          advisory: true,
          approved: advi.isAnswered,
          pending: !advi.isAnswered
        };
      },
      statusText() {
        return this.advi.isAnswered ? '已答覆' : '詢問中';
      },
      sortedAdvi() {
        const { advi, textRefs } = this;
        const { items, orderId, orderType, orderNo } = advi;
          //console.log("advi++"+JSON.stringify(advi));
          //console.log("items++"+JSON.stringify(items));
        const formatedObj = items.reduce((acc, item, index) => {
          const { insuName, dateBegin, dateEnd, lengthOfDays } = item;
          const year = Math.floor(lengthOfDays / 365);
          const periodTips = year >= 1 ? `${year}年期` : `共${lengthOfDays}天`;
          const name = `${textRefs.orderType[orderType]} ${insuName}`;
          const period = `${periodTips} ${dateBegin} - ${dateEnd}`;
          if (index === 0) return { ...acc, insuName: name, period };
          //console.log("index++"+index);
          return {
            ...acc,
            insuName: `${acc.insuName}\n${name}`,
            period: `${acc.period}\n${period}`,
          };
        }, {});

        //console.log("formatedObj+++"+JSON.stringify(formatedObj));
        return { 
          ...formatedObj,
          orderId,
          orderNo,
          lastReply: advi.lastReply ? advi.lastReply : '待回覆'
        };
      }
    },
  };
</script>
